import { Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const { Text } = Typography;

const TRUNCATE_LENGTH = 120;

function ActivityItem({ item, isExpanded, onToggleExpand, orderId, onOrderClick, borderColor }) {
  const body = item.body || '';
  const shouldTruncate = body.length > TRUNCATE_LENGTH;
  const displayBody = shouldTruncate && !isExpanded ? `${body.slice(0, TRUNCATE_LENGTH)}...` : body;

  return (
    <div className="activity-item" style={borderColor ? { borderLeftColor: borderColor } : undefined}>
      <div className="activity-item-header">
        <Text strong>{item.title}</Text>
        <Text type="secondary" className="activity-item-time">
          {item.timestamp ? dayjs(item.timestamp).format('MMM D, YYYY h:mm A') : ''}
        </Text>
      </div>
      {displayBody && (
        <div className="activity-item-body">
          {item.type === 'order' && orderId ? (
            <a href="#" onClick={(e) => { e.preventDefault(); onOrderClick?.(); }}>
              {displayBody}
            </a>
          ) : (
            displayBody
          )}
        </div>
      )}
      {shouldTruncate && (
        <button
          type="button"
          className="activity-show-more"
          onClick={onToggleExpand}
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </button>
      )}
      {item.type === 'order' && orderId && (
        <div className="activity-item-link">
          <a href="#" onClick={(e) => { e.preventDefault(); onOrderClick?.(); }}>
            View order details
          </a>
        </div>
      )}
    </div>
  );
}

export default ActivityItem;
